// extracted by css-extract-rspack-plugin
export default {"btn":"ShowMoreButton__btn--pmFij"};